import HeroLookup from './HeroLookup'
export default HeroLookup
